module.exports = __webpack_public_path__ + "img/boiler-W-idle.eb4e168a.png";